const modal = {
  close() {
    const body = document.querySelector('body')
    const modal = document.querySelector('.modal')
    modal.classList.add('hidden')
    body.classList.remove('no-scroll')
  },
  open(html) {
    const body = document.querySelector('body')
    const modal = document.querySelector('.modal')
    const container = document.querySelector('.modal-content-container')
    const content = document.querySelector('.modal-content')
    if (html) {
      content.innerHTML = ''
      content.append(html)
    }
    body.classList.add('no-scroll')
    container.classList.remove('modal-image')
    modal.classList.remove('hidden')
  },
  openImage(image) {
    this.open(image)
    const container = document.querySelector('.modal-content-container')
    container.classList.add('modal-image')
  }
}

export default modal